<ng-container *ngIf="isRowContext">
    <ng-container *ngFor="let command of commands">
        <button *ngIf="command.isVisible" class="tt-margin--left" igxButton="icon" igxRipple [title]="command.label" (click)="command.action()">
            <igx-icon>{{command.icon}}</igx-icon>
        </button>
    </ng-container>

    <div *ngIf="menuCommands" fxLayout="row" class="tt-margin--left">
        <forge-icon-button dense (click)="overflowMenu($event)">
            <forge-icon name="more_vert"></forge-icon>
        </forge-icon-button>
    </div>
</ng-container>

<forge-popover #overFlowMenu placement="bottom-end">
    <forge-list dense="true">
        <forge-list-item *ngFor="let command of menuCommands">
            <button type="button" (click)="performCommand(command, $event)" [disabled]="!command.isEnabled" [hidden]="!command.isVisible">
                <div style="color: var(--forge-theme-text-high);" class="forge-menu-expansion--child" fxLayout="row" fxLayoutAlign="space-between center">
                    {{command.label}}
                </div>
            </button>
        </forge-list-item>
    </forge-list>
</forge-popover>
